<template>
  <div class="x-table ub-box ub-ver-v">
    <table border="0" class="table ub-f1 z-width-80-precent">
      <thead @click.stop="XtheadClick($event)">
      <th v-for="(title, index) in columns" :data-key="title.key">{{title.label}}</th>
      </thead>
      <tbody ref="tbody" class="">
      <tr v-for="(item, index) in data">
        <td class="z-textAlign-center" v-for="(column, ind) in columns">
          <xcell :cell-config="column.col" :cell-string="item[column['key']]" :index="index" :cell-index="ind" :string-before="column.stringBefore" :category="column.category" @XbuttonService="XbuttonService" @XcheckService="XcheckService"/>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
  import Xcell from './Xcell.vue'
  export default {
    data() {
      return {
        type: 'sort',
        oldKey: ''
      }
    },
    props: {
      xmxy: {
        type: String,
        default: 'simple'
      },
      columns: {
        type: Array,
        default:()=> []
      },
      data: {
        type: Array,
        default:()=>[]
      },
      isHaveTheadClick: {
        type: Boolean,
        default: true
      }
    },
    components: {
      Xcell,
    },
    methods: {
      XbuttonService(type, index) {
        this.$emit('XbuttonService', type, index)
      },
      XcheckService(flag, index) {
        this.$emit('XcheckService', flag, index)
      },
      XtheadClick(e) {
        if( !this.isHaveTheadClick ) return
        let key = e.target.getAttribute('data-key')
        if(key == this.oldKey) {
          this.type = this.type === 'sort'? 'normal': 'sort'
          this.$emit('XtheadClick', key, this.type)
        }else {
          this.type = 'sort'
          this.$emit('XtheadClick', key, this.type)
        }
        this.oldKey = key
      }
    }
  }
</script>
<style scoped>
  .x-table {width: 100%;}
  .x-table .table {border-collapse: collapse; border-spacing: 0; empty-cells: show; border: 1px solid #e0e0e0; width: 100%; color: #5d5d5d; background: #fff; font-size: 1.4rem;}
  .table tbody tr{transition: all .2s ease-in;}
  .table tbody tr:hover {background-color: #eef1f6;}
  .table td span {font-size: 1.4rem;}
  .table thead th{ color: #5d5d5d; font-weight: 700; background-color: #eef1f6; font-size: 1.4rem;}
  .table thead th:hover {cursor: pointer;}
  .table th, .table td {height: 40px;min-width: 0;text-overflow: ellipsis;vertical-align: middle; border-bottom: 1px solid #dfe6ec; box-sizing: border-box;position: relative; }
  @media screen and (max-width: 1600px) {
    .table th, .table td { border-bottom: 1px solid #dfe6ec; }
  }
</style>



// WEBPACK FOOTER //
// src/components/commons/Xtable.vue